import React from 'react';
import CrearMotores from '../../../components/insumos/motores/CrearMotores';

const MotoresPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Crear Motores</h1>
      <br />
      <br />
      <CrearMotores />
    </div>
  );
};

export default MotoresPage;